<template>
  <div class="detail-tab-content">
    <div class="title">垃圾投递 <span class="tip">投递次数：{{form.formResult.garbageTotalCount}}次     总重量：{{$wtUtil.transWeight(form.formResult.garbageTotalWeight)}}kg</span></div>
    <div class="content">
      <wt-form-table :form.sync="form" >
        <wt-form-table-list slot="wtFormTableList" :form.sync="form">
          <template slot="garbageWeight" slot-scope="data">
            <span>{{ $wtUtil.transWeight(data.row.garbageWeight) }}</span>
          </template>
        </wt-form-table-list>
      </wt-form-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralUserViewGarbageDelivery',
  isAutoComponent: true,
  props: ['id'],
  data() {
    return {
      form: {
        isFormLoading: false,
        formComponent: {
          list: { type: 'default', value: '/modules/userDeliveryGarbage/userDeliveryGarbageListByUserId', params: { id: 0 }}
        },
        formInputsData: [],
        formButtonsData: [],
        formTableData: [
          { name: '垃圾', key: 'garbageName', type: 'text' },
          { name: '投递总量(kg)', key: 'garbageWeight', type: 'custom' },
          { name: '积分单价(个)', key: 'garbagePrice', type: 'text' },
          { name: '积分价值(个)', key: 'garbageTotalPrice', type: 'text' },
          { name: '投递时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '获得积分', key: 'garbageTotalPrice', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true, searchButtonHidden: true }
      }
    }
  },
  created() {
    this.form.formComponent.list.params.id = this.id
  }
}
</script>

<style>
</style>
